import React from 'react';
import { Chip, Box } from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import LockIcon from '@mui/icons-material/Lock';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import BugReportIcon from '@mui/icons-material/BugReport';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import CheckIcon from '@mui/icons-material/Check';

const coverageIcons = {
  valore_nuovo: SecurityIcon,
  incendio: LocalFireDepartmentIcon,
  furto: LockIcon,
  ricorso_terzi: SecurityIcon,
  cristalli: RadioButtonCheckedIcon,
  accessori: DirectionsCarIcon,
  eventi_naturali: AcUnitIcon,
  vandalismo: SecurityIcon,
  animali: BugReportIcon,
  collisione: DirectionsCarIcon,
  kasko: SecurityIcon
};

// Map packageType to MUI color
const colorMap = {
  Base: 'primary',
  Medium: 'warning',
  Collisione: 'success',
  Kasko: 'secondary'
};

export default function CoverageChips({ coverages, color = 'Base' }) {
  if (!coverages || coverages.length === 0) return null;

  const chipColor = colorMap[color] || 'primary';

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
      {coverages.map((coverage) => {
        const Icon = coverageIcons[coverage.id] || CheckIcon;
        return (
          <Chip
            key={coverage.id}
            size="small"
            icon={<Icon />}
            label={coverage.limit ? `${coverage.name} (${coverage.limit})` : coverage.name}
            color={chipColor}
            variant="outlined"
          />
        );
      })}
    </Box>
  );
}